/**
 * Class to build and render forms
 *
 * @author: Kete Martins
 * Date: 22/11/13
 * Time: 08:59
 */



Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.List = (function () {

    function PanelBuilderList () {

        this.list = new Monet.UI.List();
        this.list.itemRenderer = Greenmile.PanelBuilder.ItemListRender;
        this.entity = 'PanelBuilder';
        const newPanelAliasId = "new-panel-alias";

        this.setValue = function (data) {

            this.list.clearList();
            this.list.data = [];
            if (data) {
                const dataSorted = data.sort((a, b) => a.id - b.id);
                this.list.appendData(dataSorted);
            }

        };

        var getTitle = function () {
            var listTitleContainer = document.createElement('div');
            var listTitle = document.createElement('div');
            var btnNew = document.createElement('div');

            listTitleContainer.className = 'titleContainer';
            listTitle.className = 'title';
            listTitle.innerHTML = Monet.I18n.getResourcesByKey('Greenmile.PanelBuilder.ListTile');
            listTitleContainer.appendChild(listTitle);

            if (Greenmile.PanelBuilder.Utils.checkPermissions('PANEL_BUILD')) {

                btnNew.className    = 'button new';
                btnNew.title        =  Monet.I18n.getResourcesByKey('PanelBuilder.tooltip.add') + ' ' + Monet.I18n.getResourcesByKey('Greenmile.PanelBuilder.ListTile');
                
                btnNew.addEventListener('click', App.Objects.PanelBuilder.form_new);
                listTitleContainer.appendChild(btnNew);
            }

            return listTitleContainer;
        };

        this.setAliasNewPanel = function() {
            
            const newPanelAlias = {
              id: newPanelAliasId,
              name: Monet.I18n.getResourcesByKey('PanelBuilder.sidebar.newPanel.alias'),
              cardSideToShow: "FRONT",
              rootEntity: { key: "RouteView" }
            };

            const removeCrudButtons = panelsList => panelsList.rootEl.lastChild.remove();

            const panelsList = this.list;
            const newPanelAlreadyExist = panelsList.data.some( panelData => panelData.id === newPanelAliasId);

            if (!newPanelAlreadyExist) {
                panelsList.appendData([newPanelAlias]);
                removeCrudButtons(panelsList);
            }
        };

        this.removeAliasNewPanel = function() {
            const panelsListWithoutAlias = this.list.data.filter( panelData => panelData.id !== newPanelAliasId );

            if (panelsListWithoutAlias && panelsListWithoutAlias.length) {
                this.setValue(panelsListWithoutAlias);
            }
        };

        this.render = function () {

            var listContainer = document.createElement('div');
            var listTitle = getTitle();

            listContainer.className = 'listContainer';
            listContainer.appendChild(listTitle);
            listContainer.appendChild(this.list.render());

            return listContainer;

        };

    }

    return PanelBuilderList;

}());